@if (paymentMode) {
  <sd-payment-mode [paymentMode]="paymentMode" />
}
